export default __webpack_public_path__ + "static/media/temp_img.2b47daf5.jpg";